import React, { Component } from 'react'
import PropTypes from 'prop-types'

import '../App.css'

class StatusMessage extends Component {
  render() {
    let err_msg = this.props.error_msg
    //err_msg = err_msg.replace(/"/g, '')
    if (err_msg.indexOf(',') !== -1) {
      err_msg = err_msg.split(',').map(line => (
        <span>
          <br />
          {line}
        </span>
      ))
    }
    return <div className="error-style">{err_msg}</div>
  }
}

StatusMessage.propTypes = {
  error_msg: PropTypes.string.isRequired,
}

export default StatusMessage


// WEBPACK FOOTER //
// ./src/util/StatusMessage.jsx